<template>
  <div>
    <vx-card class="w-full mb-6">
      <vs-table
        ref="vendorTable"
        stripe
        class="vs-con-loading__container"
        single
        @selected="handleSelected"
        pagination
        :max-items="itemsPerPage"
        search
        :data="vendors"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow"
        >
          <div class="flex flex-wrap-reverse items-center">
            <!-- ADD NEW -->
            <div
              class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
              @click="showDetailsCard"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="modifiedOn">Modified On</vs-th>
          <vs-th sort-key="modifiedBy">Modified By</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="vendor"
            :key="indextr"
            v-for="(vendor, indextr) in data"
          >
            <vs-td :data="data[indextr].vendor">
              {{ vendor.name }}
            </vs-td>
            <vs-td :data="data[indextr].modifiedOn">
              {{ vendor.modifiedOn.replace("T", " ").split(".")[0] }}
            </vs-td>
            <vs-td :data="data[indextr].modifiedBy">
              {{ vendor.modifiedBy }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vx-card class="mb-6" :title="cardTitle" v-show="!isInfoHidden">
      <div class="vx-row mb-3">
        <div class="vx-col sm:w-1/2 w-full">
          <label>Name</label>
          <vs-input autocomplete="off" class="w-full" v-model="formData.name" />
        </div>
      </div>
      <div v-if="formData.id">
        <vs-divider>Integration Credentials</vs-divider>
        <div class="vx-row mb-3">
          <div class="vx-col sm:w-1/2 w-full">
            <label>Username</label>
            <vs-input
              autocomplete="off"
              readOnly="true"
              class="w-full"
              v-model="formData.integrationUsername"
            />
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <label>Password</label>
            <vs-input
              autocomplete="off"
              readOnly="true"
              class="w-full"
              v-model="formData.integrationPassword"
            />
          </div>
        </div>
      </div>
      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button
            color="success"
            class="mr-3 mb-2 vs-con-loading__container"
            :disabled="isDisabled"
            @click.prevent="saveEditVendor"
            ref="saveEditButton"
            >Save</vs-button
          >
          <vs-button
            v-if="formData.id"
            color="danger"
            class="mr-5 mb-2 vs-con-loading__container"
            @click.prevent="deleteVendor"
            ref="deleteButton"
            >Delete</vs-button
          >
          <vs-button
            color="warning"
            type="border"
            class="mb-2"
            @click="cancelAdd"
            >Cancel</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card
      title="Vouchers & Discount"
      v-if="formData.id && !addNewDiscountCode && !addNewVouchers"
    >
      <div>
        <vs-divider>Vouchers</vs-divider>
        <vs-collapse class="border">
          <vs-collapse-item>
            <div slot="header">Vouchers</div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-table
                  ref="voucherTable"
                  stripe
                  class="vs-con-loading__container"
                  single
                  pagination
                  :max-items="itemsPerPage"
                  search
                  :data="vouchers"
                >
                  <div
                    slot="header"
                    class="flex flex-wrap-reverse items-center flex-grow"
                  >
                    <div class="flex flex-wrap-reverse items-center">
                      <!-- ADD NEW -->
                      <div
                        class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                        @click="addNewVouchersFunction"
                      >
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Add New</span>
                      </div>
                    </div>
                  </div>

                  <template slot="thead">
                    <vs-th sort-key="voucherTypeName">Voucher Type</vs-th>
                    <vs-th sort-key="voucherCode">Voucher Code</vs-th>
                    <vs-th sort-key="createdOn">Created On</vs-th>
                    <vs-th sort-key="redeemedOn">Redeemed On</vs-th>
                    <vs-th sort-key="status">Status</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr
                      :data="voucher"
                      :key="indextr"
                      v-for="(voucher, indextr) in data"
                    >
                      <vs-td :data="data[indextr].voucherTypeName">
                        {{ voucher.voucherTypeName }}
                      </vs-td>
                      <vs-td :data="data[indextr].voucherCode">
                        {{ voucher.voucherCode }}
                      </vs-td>
                      <vs-td :data="data[indextr].createdOn">
                        {{ voucher.createdOn.replace("T", " ").split(".")[0] }}
                      </vs-td>
                      <vs-td :data="data[indextr].redeemedOn">
                        {{
                          voucher.redeemedOn
                            ? voucher.redeemedOn.replace("T", " ").split(".")[0]
                            : "N/A"
                        }}
                      </vs-td>
                      <vs-td :data="data[indextr].status">
                        <vs-chip
                          :color="
                            voucher.status == 'Redeemed' ? 'warning' : 'success'
                          "
                          >{{ voucher.status }}</vs-chip
                        >
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
        <vs-divider>Discount Codes</vs-divider>
        <vs-collapse class="border">
          <vs-collapse-item>
            <div slot="header">Discount Codes</div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-table
                  ref="voucherTable"
                  stripe
                  class="vs-con-loading__container"
                  single
                  pagination
                  :max-items="itemsPerPage"
                  search
                  :data="discountCodeList"
                >
                  <div
                    slot="header"
                    class="flex flex-wrap-reverse items-center flex-grow"
                  >
                    <div class="flex flex-wrap-reverse items-center">
                      <!-- ADD NEW -->
                      <div
                        class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                        @click="addNewDiscountCodeFunction"
                      >
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary">Add New</span>
                      </div>
                    </div>
                  </div>

                  <template slot="thead">
                    <vs-th sort-key="voucherCode">Discount Code</vs-th>
                    <vs-th sort-key="createdOn">Created On</vs-th>
                    <vs-th sort-key="fromDate">From</vs-th>
                    <vs-th sort-key="toDate">To</vs-th>
                    <vs-th sort-key="usesLeft">Uses Left</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr
                      :data="voucher"
                      :key="indextr"
                      v-for="(voucher, indextr) in data"
                    >
                      <vs-td :data="data[indextr].voucherCode">
                        {{ voucher.voucherCode }}
                      </vs-td>
                      <vs-td :data="data[indextr].createdOn">
                        {{ voucher.createdOn.replace("T", " ").split(".")[0] }}
                      </vs-td>
                      <vs-td :data="data[indextr].fromDate">
                        {{ voucher.fromDate.replace("T", " ").split(".")[0] }}
                      </vs-td>
                      <vs-td :data="data[indextr].toDate">
                        {{ voucher.toDate.replace("T", " ").split(".")[0] }}
                      </vs-td>
                      <vs-td :data="data[indextr].usesLeft">
                        {{ voucher.usesLeft }}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </vx-card>
    <vx-card v-if="addNewVouchers" title="Generate Vouchers">
      <div class="vx-row mb-3">
        <div class="vx-col sm:w-1/2 w-full">
          <label>Amount Of Vouchers</label>
          <vs-input
            autocomplete="off"
            itemtype="number"
            onclick="this.select()"
            class="w-full"
            v-model="voucherFormData.voucherAmount"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <label>Voucher Duration in Months</label>
          <vs-input
            autocomplete="off"
            itemtype="number"
            onclick="this.select()"
            class="w-full"
            v-model="voucherFormData.months"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <label>Subscription Type</label>
          <v-select
            placeholder="Search / Select Subscription Type"
            v-model="voucherFormData.subscriptionType"
            :options="subscriptionTypes"
          ></v-select>
        </div>
      </div>
      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button
            color="success"
            class="mr-3 mb-2 vs-con-loading__container"
            @click.prevent="generateVouchers"
            ref="generateVouchersButton"
            >Generate</vs-button
          >
          <vs-button
            color="warning"
            type="border"
            class="mb-2"
            @click="cancelGenerateCVouchers"
            >Cancel</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card v-if="addNewDiscountCode" title="Create Discount Code">
      <div class="vx-row mb-3">
        <div class="vx-col sm:w-1/2 w-full">
          <label>Discount %</label>
          <vs-input
            autocomplete="off"
            itemtype="number"
            onclick="this.select()"
            class="w-full"
            v-model="discountVoucherFormData.discount"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <label>Total Uses</label>
          <vs-input
            autocomplete="off"
            itemtype="number"
            onclick="this.select()"
            class="w-full"
            v-model="discountVoucherFormData.uses"
          />
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <label>Subscription</label>

          <vs-select
            placeholder="Search / Select Subscription Type"
            class="w-full pb-3"
            multiple
            vs-multiple
            autocomplete
            v-model="selectedSubscriptions"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.label"
              v-for="(item, index) in subscriptionTypes"
            />
          </vs-select>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <label>From Date</label>
          <datepicker
            ref="fromPicker"
            v-model="discountVoucherFormData.fromDate"
            :inline="false"
            :format="format"
            :highlighted="highlightedFn"
          ></datepicker>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <label>To Date</label>
          <datepicker
            ref="fromPicker"
            v-model="discountVoucherFormData.toDate"
            :inline="false"
            :format="format"
            :highlighted="highlightedFn"
          ></datepicker>
        </div>
      </div>
      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button
            color="success"
            class="mr-3 mb-2 vs-con-loading__container"
            @click.prevent="createDiscountCode"
            ref="generateVouchersButton"
            >Generate</vs-button
          >
          <vs-button
            color="warning"
            type="border"
            class="mb-2"
            @click="cancelGenerateCVouchers"
            >Cancel</vs-button
          >
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import { get } from "jquery";
import index from "vue-prism-component";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    "v-select": vSelect,
    Datepicker,
  },
  data() {
    return {
      format: "yyyy-MM-dd",
      loadingColor: "#fff",
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      isInfoHidden: true,
      vendors: [],
      vouchers: [],
      subscriptionTypes: [],
      voucherFormData: {
        voucherAmount: 1,
        subscriptionType: null,
        months: 1,
      },
      discountVoucherFormData: {
        fromDate: new Date(),
        toDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
        uses: 10,
        discount: 50.0,
      },
      selectedSubscriptions: [],
      discountCodeList: [],
      addNewVouchers: false,
      addNewDiscountCode: false,
      formData: {
        id: 0,
        name: "",
        integrationUsername: "",
        integrationPassword: "",
      },
      mode: "",
      cardTitle: "",
      highlightedFn: {
        customPredictor(date) {
          this.today = new Date();

          if (
            date.getDate() == this.today.getDate() &&
            date.getMonth() == this.today.getMonth()
          ) {
            return true;
          }
        },
      },
    };
  },
  computed: {
    isDisabled: function () {
      return !this.formData.name;
    },
  },
  methods: {
    initValues() {
      this.mode = "";
      this.isInfoHidden = true;
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.integrationUsername = "";
      this.formData.integrationPassword = "";
      this.vouchers = [];
    },
    cancelAdd() {
      this.initValues();
      this.isInfoHidden = true;
    },
    loadData() {
      var self = this;
      self.showLoadingOnElement("vendorTable", 1, "corners");

      var onSuccess = function (response) {
        self.vendors = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.vendorTable.$el);
      };
      self.$ajaxGet(self, "Vendor/List", onSuccess, onFinally);
    },
    showDetailsCard() {
      var self = this;
      self.initValues();
      self.isInfoHidden = false;
      self.mode = "Add New";
      self.cardTitle = "Create New Vendor";
    },
    handleSelected(tr) {
      var self = this;
      self.isInfoHidden = false;
      self.mode = "Update";
      self.cardTitle = "Edit Vendor";

      self.formData.id = tr.id;
      self.formData.name = tr.name;
      self.formData.integrationUsername = tr.integrationUsername;
      self.formData.integrationPassword = tr.integrationPassword;

      setTimeout(() => {
        self.loadVouchers();
        self.getDiscountCodes();
      }, 50);
    },
    loadVouchers() {
      var self = this;
      self.showLoadingOnElement("voucherTable", 1, "corners");

      var onSuccess = function (response) {
        self.vouchers = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.voucherTable.$el);
      };
      self.$ajaxGet(
        self,
        `Vendor/GetVouchers/${self.formData.id}`,
        onSuccess,
        onFinally
      );
    },
    saveEditVendor() {
      var self = this;
      self.showLoadingOnElement("saveEditButton", 0.45, "material");

      var onSuccess = (response) => {
        this.initValues();
        this.loadData();
        this.$vs.loading.close(this.$refs.saveEditButton.$el);
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: "Vendor Saved",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-save",
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.saveEditButton.$el);
      };

      self.$ajaxPost(
        self,
        "Vendor/AddUpdate",
        self.formData,
        onSuccess,
        onFinally
      );
    },
    deleteVendor() {
      var self = this;
      self.showLoadingOnElement("deleteButton", 0.45, "material");

      var onSuccess = (response) => {
        self.initValues();
        self.loadData();
        self.scrollToNavbar();
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: "Vendor Deleted",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-trash",
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };
      self.formData.id = parseInt(self.formData.id);
      self.$ajaxDelete(
        self,
        `Vendor/Delete/${self.formData.id}`,
        onSuccess,
        onFinally
      );
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale,
      });
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true,
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("navbarGlobal"),
        500,
        scrollOptions
      );
    },
    addNewVouchersFunction() {
      this.addNewVouchers = true;
    },
    addNewDiscountCodeFunction() {
      this.addNewDiscountCode = true;
    },
    cancelGenerateCVouchers() {
      this.addNewVouchers = false;
    },
    cancelCreateDiscountCode() {
      this.addNewDiscountCode = false;
    },
    getSubscriptionTypes() {
      var self = this;
      var onSuccess = function (response) {
        self.subscriptionTypes = response.data;
      };
      self.$ajaxGet(self, "public/GetSubscriptionTypes", onSuccess);
    },
    generateVouchers() {
      var self = this;

      var onSuccess = (response) => {
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: `Vouchers Generated`,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        self.cancelGenerateCVouchers();
        //Download txt file
        //convert list of string into a single string with new lines
        var content = response.data.join("\n");
        self.downloadTxtFile(content);
      };

      var onFinally = function () {
        self.loadVouchers();
        self.$vs.loading.close(self.$refs.generateVouchersButton.$el);
      };

      //if any data does not match the required format, display error message
      if (
        !self.voucherFormData.subscriptionType ||
        !self.voucherFormData.voucherAmount ||
        !self.voucherFormData.months
      ) {
        self.$vs.notify({
          title: "Error",
          color: "danger",
          text: "Please fill in all fields",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x",
        });
        return;
      }
      self.showLoadingOnElement("generateVouchersButton", 0.45, "material");

      var objectToSendIn = {
        vendorId: self.formData.id,
        subscriptionTypeId: self.voucherFormData.subscriptionType.value,
        voucherAmount: self.voucherFormData.voucherAmount,
        months: self.voucherFormData.months,
      };

      self.$ajaxPost(
        self,
        "Vendor/GenerateVouchers",
        objectToSendIn,
        onSuccess,
        onFinally
      );
    },
    downloadTxtFile(content) {
      const blob = new Blob([content], { type: "text/plain" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "file.txt";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    getDiscountCodes() {
      var self = this;
      var onSuccess = function (response) {
        self.discountCodeList = response.data;
      };
      self.$ajaxGet(
        self,
        `Vendor/GetDiscountCodes?vendorId=${self.formData.id}`,
        onSuccess
      );
    },
    createDiscountCode() {
      var self = this;
      self.selectedSubscriptions;
      //validate fields

      if (
        self.discountVoucherFormData.toDate <=
        self.discountVoucherFormData.fromDate
      ) {
        self.$vs.notify({
          title: "Error",
          color: "danger",
          text: "Please Make sure the To Date is greater than the From Date",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x",
        });
        return;
      }
      if (self.uses < 1) {
        self.$vs.notify({
          title: "Error",
          color: "danger",
          text: "Please Make sure the Uses is greater than 0",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-x",
        });
        return;
      }

      //send api call to create
      var onSuccess = (response) => {
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: `Discount Code Created`,
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check",
        });
        var content = response.data.join("\n");
        self.cancelCreateDiscountCode();
        self.getDiscountCodes();
        self.downloadTxtFile(content);
      };

      var onFinally = function () {
        self.$vs.loading.close(self.$refs.generateVouchersButton.$el);
      };

      self.showLoadingOnElement("generateVouchersButton", 0.45, "material");

      self.$ajaxPost(
        self,
        "Vendor/GenerateDiscountCode",
        {
          vendorId: self.formData.id,
          fromDate: self.discountVoucherFormData.fromDate,
          toDate: self.discountVoucherFormData.toDate,
          uses: self.discountVoucherFormData.uses,
          subscriptionDiscounts: self.selectedSubscriptions.map((x) => {
            return {
              subscriptionTypeId: x,
              amount: self.discountVoucherFormData.discount,
            };
          }),
        },
        onSuccess,
        onFinally
      );
    },
  },
  mounted() {
    var self = this;
    self.loadData();
    self.getSubscriptionTypes();
    self.isMounted = true;
  },
};
</script>
